<template>
  <div class="card">
    <div class="show-box" @click="toDetail(order)">
      <span class="info-tradeTypeName">{{ tradeTypeName }}</span>
      <div class="show-box-top">
        <div class="show-box-top-name">{{ order.orderDetailInfoList[0].commodityName }}</div>
        <div class="show-box-top-code">
          <span>订单编号:</span>
          <span>{{ order.orderNo }}</span>
        </div>
        <div class="show-box-top-statu">
          <span> {{ statusName }}</span>
          <img src="@/assets/imgs/order/CaretRight@2x.png" alt="">
        </div>
      </div>
      <div class="show-box-midde">
        <div class="show-box-midde-seller">
          <span>卖家:</span>
          <span>{{ order.sellerEnterpriseName }}</span>
        </div>
        <div class="show-box-midde-Specifications">
          <span>规格:</span>
          <span>{{ order.packing }}</span>
        </div>
        <div class="show-box-midde-Order-type">
          <span>订单类型:</span>
          <span>{{ tradeTypeName }}</span>
        </div>
        <div class="show-box-midde-time">
          <span>订单生成时间:</span>
          <span>{{ order.createTime }}</span>
        </div>
      </div>
      <div class="show-box-bottom">
        <div class="show-box-bottom-mode">{{ shipModeName }}</div>
        <div class="show-box-bottom-address">
          交货地:test
        </div>
        <div class="show-box-bottom-pice">
          <span>订单单价:</span>
          <span>
            {{$utils.amount(order.orderDetailInfoList[0].price, 2)}}
            元/吨
          </span>
        </div>
        <div class="show-box-bottom-order">
          <span>订单重:</span>
          <span>
            {{order.orderDetailInfoList[0].quantity}}
            吨
          </span>
        </div>
        <div class="show-box-bottom-total">
          <span>订单总金额:</span>
          <span class="aa">
            <span>¥</span>
            <span>{{ $utils.amount(order.orderDetailInfoList[0].amount, 2) }}</span>
          </span>
        </div>
      </div>
    </div>
    <!-- <div class="card-btn" v-if="order.tradeType == 'JH'">
      <van-button class="btn" :style="{ display: /^0_/.test(order.status) ? 'block' : 'none' }" @click="submitOrder(order)">确认订单</van-button>
      <van-button v-if="
          order.status == '3' ||
          order.status == '9' ||
          order.status == '4' ||
          order.status == '2' ||
          order.status == '2-2'
        " @click="viewAgreement(order.id)" class="btn">订单协议</van-button>
      <van-button v-if="order.status == '4' || order.status == '-1'" class="btn" @click="goAnotherOrder(order)">再来一单</van-button>
    </div> -->
    <viewAgreement class="viewAgreement" ref="Agreement"></viewAgreement>
  </div>
</template>
<script>
import viewAgreement from "@/components/viewAgreement";
import orderApi from "@/request/orderApi";
export default {
  name: "OrderCard",
  components: {
    viewAgreement,
  },
  props: {
    order: Object,
  },
  data() {
    return {
      agreementSignList: [],
    };
  },
  computed: {
    statusCode() {
      return this.$store.state.valueSet;
    },
    shipModeName() {
      let shipModeName;
      switch (this.order.orderDetailInfoList[0].shipMode) {
        case "Z":
          shipModeName = "直发";
          break;
        case "K":
          shipModeName = "库发";
          break;
        case "D":
          shipModeName = "断卖";
          break;
      }
      return shipModeName;
    },
    statusName() {
      let statusName;
      switch (this.order.status) {
        case "1":
          statusName = "待审核";
          break;
        case "2":
          statusName = "审核中";
          break;
        case "3":
          statusName = "待发货";
          break;
        case "4":
          statusName = "发货中";
          break;
        case "9":
          statusName = "已完成";
          break;
        case "0_1":
          statusName = "待确认";
          break;
        case "0_2":
          statusName = "待确认";
          break;
        case "0_3":
          statusName = "待确认";
          break;
        case "0_4":
          statusName = "待审核";
          break;
        case "-1":
          statusName = "已取消";
          break;
        case "2_2":
          statusName = "审核中";
          break;
        case "1_1":
          statusName = "待审核";
          break;
      }
      return statusName;
    },
    tradeTypeName() {
      let tradeTypeName;
      switch (this.order.tradeType) {
        case "JH":
          tradeTypeName = "计划";
          break;
        case "JJ":
          tradeTypeName = "竞拍";
          break;
        case "PD":
          tradeTypeName = "拼单";
          break;
        case "SG":
          tradeTypeName = "闪购";
          break;
        case "CH":
          tradeTypeName = "现货";
          break;
      }
      return tradeTypeName;
    },
  },
  methods: {
    toDetail(item) {
      this.$router.push("/orderDetail?id=" + item.id);
    },
    submitOrder(item) {
      this.$router.push("/orderDetail?id=" + item.id);
    },
    // 再来一单
    goAnotherOrder(order) {
      console.log(order);
      let query = {
        tradeId: order.id,
        stockId: order.id,
        stationName: order.warehouseName,
        stationCode: order.warehouseCode,
        quantity: order.quantity,
        price: order.price,
      };
      this.$router.push({
        path: "/planSale/OrderSubmit",
        query,
      });
    },
    goComment() {
      this.$router.push("/comment");
    },
    viewComment(order) {
      this.$router.push("/comment?id=" + order.id);
    },

    // 协议
    viewAgreement(id) {
      this.$router.push("/viewAgreement?id=" + id);
    },
    cancelOrder(item) {
      this.$dialog
          .confirm({
            title: "撤销订单",
            message: "确认要撤销订单吗？",
          })
          .then(() => {
            let params = item.id;
            orderApi.cancel(params).then((res) => {
              if (res.returnCode == "0") {
                this.$emit("cancelOrder");
              } else {
                this.$toast({
                  type: "fail",
                  message: res.returnMessage,
                  duration: 1500,
                });
              }
            });
          })
          .catch(() => {
            // on cancel
          });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.card {
  padding-top: 8px;

.card-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 120px;

.btn {
  min-width: 200px;
  height: 72px;
  background: $gradientColor;
  color: #ffffff;
  font-size: 32px;
  border-radius: 40px;
}
}
}

.show-box {
  box-sizing: border-box;
  margin: 24px 32px;
  padding: 58px 32px 38px;
  width: 686px;
// height: 728px;
  background: #FFFFFF;
  border-radius: 16px;
  position: relative;

.info-tradeTypeName {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 16px 0px 16px 0px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 24px;
  color: #FB6B01;
  background-color: #fff3eb;
  width: 96px;
  height: 42px;
  line-height: 42px;
  text-align: center;
}

.show-box-top {
  position: relative;
  border-bottom: 1px solid #eee;

.show-box-top-name {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 28px;
  color: #333333;
  line-height: 33px;
  margin-bottom: 8px;
}

.show-box-top-code {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 24px;
  color: #666666;
  line-height: 28px;
  margin-bottom: 32px;
}

.show-box-top-statu {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #197AFA;
  position: absolute;
  top: 0;
  right: 0;

img {
  width: 10px;
  height: 20px;
  margin-left: 16px;
}
}
}

.show-box-midde {
  border-bottom: 1px solid #eee;

.show-box-midde-seller {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 28px;
  color: #333333;
  margin-top: 32px;
  margin-bottom: 16px;
  line-height: 33px;
}

.show-box-midde-Specifications {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #666666;
  margin-bottom: 16px;
  line-height: 33px;
}

.show-box-midde-Order-type {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #666666;
  margin-bottom: 16px;
  line-height: 33px;
}

.show-box-midde-time {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #666666;
  margin-bottom: 32px;
  line-height: 33px;
}
}

.show-box-bottom {
  position: relative;

.show-box-bottom-mode {
  position: absolute;
  top: 0;
  right: 0;
  width: 80px;
  height: 36px;
  background: rgba(153, 179, 250, 0.1);
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #99B3FA;
  text-align: center;
  line-height: 36px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 24px;
  color: #81A1F7;
}

.show-box-bottom-address {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 28px;
  color: #333333;
  margin: 20px 0 16px;
  line-height: 33px;
}

.show-box-bottom-pice {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #666666;
  margin-bottom: 16px;
  line-height: 33px;
}

.show-box-bottom-order {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #666666;
  margin-bottom: 30px;
  line-height: 33px;
}

.show-box-bottom-total {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #666666;
  line-height: 33px;
  margin-bottom: 28px;
  position: relative;

.aa {
  position: absolute;
  right: 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 24px;
  line-height: 33px;
  color: #FF5500;

span:nth-child(2) {
  font-size: 48px;
}
}
}
}
}
</style>
